import { z } from 'zod';

import { flowSearchSchema } from '@/shared/flow/define-flow';

/**
 * `validateSearch` de `/ccb/simular` e `/ccb/contratar/credito-pessoal` (U07): `simulationMode=fgts` filtra os
 * produtos de FGTS nas duas, como o `applyFiltersForProducts` do legado (StringFormats.ts:341-348). Leve, para a rota.
 */
export const simulationSearch = z.object({
  simulationMode: z.string().optional().catch(undefined),
});
export type SimulationSearch = z.infer<typeof simulationSearch>;

/** `/ccb/contratar/credito-pessoal`: o `simulationMode` e a etapa (`?passo=`, W06 da discovery/13). */
export const personalCreditSearch = simulationSearch.extend(flowSearchSchema().shape);
